export default () => ({
    activeCategory: '1',
    activeItem: '',

    async init() {
        this.activeCategory = 'nurture'
        this.activeItem = '1'
    },

    category: {
        ['@click']() {
            this.activeCategory = this.$el.dataset.category
            this.activeItem = '1'
        },

        [':class']: 'activeCategory === $el.dataset.category ? "--is-active" : ""',
    },

    categoryDetails: {
        [':class']: 'activeCategory === $el.dataset.category ? "--is-active" : ""',
    },

    categoryItem: {
        ['x-show']: 'activeItem === $el.dataset.item',
    },

    // Function available but not used
    open() {
        this.activeCategory = this.$el.dataset.category
    },

    toggle() {
        this.activeItem = this.$el.dataset.item
    },
})
